// Route shape of the employer-facing portfolio. Kept in a tiny standalone
// module (no React, no CSS) because src/App.js needs it eagerly to decide
// whether to render the isolated portfolio shell, while everything else in
// this folder is lazy-loaded. Mirrors HIRE_ROUTES in scripts/lib/routes.js.
//
//   /hire, /en/hire                       portfolio home (fi, en)
//   /hire/projects/:slug                  a single project (fi)
//   /en/hire/projects/:slug               a single project (en)
//
// Project slugs are language-independent (src/data/projects.json), so the
// same slug addresses the same project in both locales.
const HIRE_PATH_RE = /^(\/en)?\/hire(?:\/projects\/([^/]+))?\/?$/;

export function matchHirePath(pathname) {
  const match = HIRE_PATH_RE.exec(pathname);
  if (!match) return null;
  return { locale: match[1] ? 'en' : 'fi', slug: match[2] || null };
}

export const hireBasePath = (locale) => (locale === 'en' ? '/en/hire' : '/hire');

export const hireProjectPath = (locale, slug) => `${hireBasePath(locale)}/projects/${slug}`;

export const hireSectionPath = (locale, sectionId) => `${hireBasePath(locale)}#${sectionId}`;

export const otherHireLocale = (locale) => (locale === 'en' ? 'fi' : 'en');

// The same page in the other language (keeps the selected project).
export function switchHirePathLocale(pathname, locale) {
  const withoutLocale = pathname.replace(/^\/en(?=\/hire)/, '');
  return otherHireLocale(locale) === 'en' ? `/en${withoutLocale}` : withoutLocale;
}
